/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure restore point specification for VM backup conversion
*/
export class AzureRestorePointSpec {
  /**
  * Azure restore point full resource ID
  */
  'restorePointId': string;
  /**
  * Azure location
  */
  'region': string;
  /**
  * Vault name (optional - can be derived from restorePointId)
  */
  'vaultName'?: string;
  /**
  * Vault resource group (optional)
  */
  'vaultResourceGroup'?: string;
  /**
  * Vault type (optional)
  */
  'vaultType'?: AzureRestorePointSpecVaultTypeEnum;
  /**
  * Restore point creation time (optional - fetched from Azure if not provided)
  */
  'recoveryPointTime'?: Date;
  /**
  * Azure disk resource IDs to restore from this restore point
  */
  'diskIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restorePointId",
      "baseName": "restorePointId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultName",
      "baseName": "vaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultResourceGroup",
      "baseName": "vaultResourceGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultType",
      "baseName": "vaultType",
      "type": "AzureRestorePointSpecVaultTypeEnum",
      "format": ""
    },
    {
      "name": "recoveryPointTime",
      "baseName": "recoveryPointTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "diskIds",
      "baseName": "diskIds",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureRestorePointSpec.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AzureRestorePointSpecVaultTypeEnum {
  RecoveryServicesVault = 'Recovery Services Vault',
  BackupVault = 'Backup Vault'
}

